module.exports = __webpack_public_path__ + "font_darts_son.2d980380.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/child_to_parent/font_darts_son.png
// module id = vN9s
// module chunks = 0